import React, { useEffect, useRef, useState } from 'react'
import { ScrollView, useWindowDimensions, View } from 'react-native'
import { Text } from 'react-native-svg'
import { getDisclaimerText } from '../../../Redux/Actions/checkInAction'
import { useCssStyle } from '../../../customHook/getCssStyle'
import SignatureCanvas from 'react-signature-canvas'
import HeaderWithBack from '../../../components/Header/headerWithBack'
import { useTranslation } from 'react-i18next'
import CustomCheckBoxWithProps from '../../../components/checkBox/customCheckBox'
import CustomPressable from '../../../components/customPressable/customPressable'
import FetchingDataScreen from '../../../components/fetchingDataScreen'
import html2canvas from 'html2canvas';
import { useDispatch } from 'react-redux'
import { setRenderFlashMessage } from '../../../Redux/Actions/appConfigAction'

const Disclaimer = (props) => {
  const { t } = useTranslation();
  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const { disclaimerText, guestdetails, checkInConfigLocalCopy, handleNext, handleGoBack, updateFetchApiError, updateLoaderState } = props;

  const signatureRef = useRef(null);

  const [agreeDisclaimer, setAgreeDisclaimer] = useState(false);
  const [enableAccept, setEnableAccept] = useState(false);
  const [disclaimerSSArray, setDisclaimerSSArray] = useState([]);



  const handleAccept = async () => {
    setEnableAccept(false);
    const inputs = document.querySelectorAll('.preview-text input, .preview-text select');

    let isEmpty = false;
    let reverseInputsArray = Array.from(inputs).reverse();
    reverseInputsArray.forEach(input => {
      if (input.classList.contains('discalimer_mandatory') && (!input.value || input.value.trim() == '')) {
          dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter all the mandatory fields to proceed" }));
        isEmpty = true;
        return;
      }
    });

    // If isEmpty is true, some input is empty
    if (isEmpty) {
        setEnableAccept(true);
        return;
    }
    takeScreenshot();
  }

  const takeScreenshot = () => {
    updateLoaderState(true, "Please wait...");
    const divToCapture = document.getElementById('legal_document');

    if (divToCapture) {

      // Apply inline CSS if needed for A4 size formatting
      const originalWidth = divToCapture.style.width;
      const originalPadding = divToCapture.style.padding;
      divToCapture.style.width = '210mm'; // A4 width
      divToCapture.style.padding = '20px'

      html2canvas(divToCapture, {
          useCORS: true, // Handle cross-origin images
          scale: 2, // Increase resolution
          scrollX: 0, // Handle scroll position
          scrollY: -window.scrollY // Adjust scroll position
      }).then(canvas => {
          const screenshot = canvas.toDataURL("image/jpeg", 0.3);

          // Restore original styles
          divToCapture.style.width = originalWidth;
          divToCapture.style.padding = originalPadding;

          setDisclaimerSSArray(screenshot);
      }).catch(error => {
          console.error('Error capturing screenshot:', error);
          updateLoaderState(false);
          const errorMessage = error?.response?.data?.header?.status?.msg || error?.message || "Something went wrong";
          dispatch(setRenderFlashMessage(true, { type: "danger", message: errorMessage }));
      }).finally(() => {
        setEnableAccept(true);
      });
    } else {
      updateLoaderState(false);
      console.error('Element with specified ID not found');
    }
  };

  const handleReset = () => {
      signatureRef.current?.clear();
      setAgreeDisclaimer(false);
      setEnableAccept(false);
  }

  const handleAcceptDisclaimer = () => {
    handleNext(disclaimerSSArray);
  }

  useEffect(() => {
    if (disclaimerSSArray?.length > 0) {
        handleAcceptDisclaimer();
        setDisclaimerSSArray([]);
    }

    console.log(disclaimerSSArray)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disclaimerSSArray])

  const customDisclaimerTitleStyle = getStyles([
      'widgetmainContainerHeaderTitle',
      'checkInDisclaimer_HeaderTitle'
  ]);

  const signatureCanvasStyle = getStyles(['checkInDisclaimer_signature_canvas', { className: 'sigCanvas', width: useWindowDimensions().width - 35}])
  return (
    <View style={getStyles(['widgetRootContainer', 'checkInDisclaimerRootContainer'])}>
      <HeaderWithBack handleCustomBackPress={()=>handleGoBack()}/>

      <ScrollView
        contentContainerStyle={getStyles(['widgetmainContainer', 'checkInDisclaimerMainContainer'])}
        showsVerticalScrollIndicator={false}
      >
        <View style={getStyles(['widgetmainContainerHeaderContainer', 'checkInDisclaimerHeaderContainer'])}>
          <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'checkInDisclaimerHeaderTitleContainer'])}>
            <Text style={customDisclaimerTitleStyle}>{t('check_in.disclaimerHeading')}</Text>
          </View>
        </View>

        <View style={getStyles(['widgetmainContainerChildContainer', 'checkInDisclaimerMainContainerChildContainer'])}>
          <div id='legal_document' className='preview-text'>
            <View style={getStyles(['checkInDisclaimer_textContainer'])}>
              <div dangerouslySetInnerHTML={{ __html: disclaimerText }}></div>
            </View>


            <View style={getStyles(['checkInDisclaimer_checkbox'])}>
              <CustomCheckBoxWithProps
                value={agreeDisclaimer}
                onValueChange={() => setAgreeDisclaimer(prev => !prev)}
              />
              <Text style={getStyles(['checkInDisclaimer_checkbox_text', {}])} >{t('check_in.disclaimer_terms_condition')}</Text>
            </View>

            <View style={getStyles(['checkInDisclaimer_signature'])}>
              <SignatureCanvas
                ref={signatureRef}
                onBegin={() => setEnableAccept(true)}
                penColor={signatureCanvasStyle?.penColor || "#000000"}
                canvasProps={signatureCanvasStyle}
                
              />
            </View>

          </div>
        </View>
      </ScrollView>

      <View id='disclaimerFooterContainer' style={getStyles(['disclaimerFooterContainer'])}>
        <CustomPressable
          style={getStyles(['secondaryBtn'])}
          onPress={handleReset}
        >
          <Text style={getStyles(['secondaryBtnTxt'])}>{t('check_in.reset')}</Text>
        </CustomPressable>
        <CustomPressable
          style={getStyles(['primaryBtn'])}
          disabled={!enableAccept || !agreeDisclaimer}
          onPress={handleAccept}
        >
          <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.accept')}</Text>
        </CustomPressable>
      </View>
    </View>
  )
}

export default Disclaimer
